<script lang="ts">
    import { Component, Vue, toNative, Prop, Emit } from 'vue-facing-decorator';
    import { ISwitchState } from './switch-state.interface';
    import { SwitchType } from './switch-type.definition';
    import { ObjectUtils } from '../../../../../../modules';
    import { SwitchLabelPosition } from './switch-label-position.definition';
    import { AccessibilityHandler } from "webshop-modules/accessibility";

    @Component
    class Switch extends Vue {
        @Prop({ required: true }) 
        state!: ISwitchState;

        @Emit() 
        public stateChange(update: ISwitchState): ISwitchState {
            return update;
        }

        public readonly SwitchLabelPosition: typeof SwitchLabelPosition = SwitchLabelPosition;
        public readonly SwitchType: typeof SwitchType = SwitchType;

        public handleSwitchChange(event: Event): void {
            this.setSwitchTo((event.target as HTMLInputElement).checked);
        }

        public handleKeyPress(event: KeyboardEvent): void {
            AccessibilityHandler.handleActionWithCallback(event, () => {
                if (this.state.isDisabled) {
                    return;
                }

                this.setSwitchTo(!this.state.state);
            });
        }

        private setSwitchTo(toggled: boolean) {
            const update = ObjectUtils.clone<ISwitchState>(this.state);
            update.state = toggled;
            this.stateChange(update);
        }
    }

    export default toNative(Switch);
</script>
<template>
    <div
        v-bind:class="{
            '-nolabel': !state.label || state.label.length === 0,
            '-leftlabel': state.label && state.labelPosition === SwitchLabelPosition.Before,
            '-error': state.type === SwitchType.Error,
            '-info': state.type === SwitchType.Info,
            '-success': state.type === SwitchType.Success,
            '-warning': state.type === SwitchType.Warning,
        }"
        @keydown="handleKeyPress"
        class="a-switch"
        tabindex="0">
        <label class="a-switch__form">
            <input
                v-bind:disabled="state.isDisabled"
                v-bind:checked="state.state"
                v-on:change="handleSwitchChange($event)"
                class="a-switch__input"
                type="checkbox" />

            <div class="a-switch__slider">
                <span class="a-switch__labelon">ON</span>
                <span class="a-switch__labeloff">OFF</span>
            </div>
        </label>

        <div v-if="state.label && state.label.length !== 0" class="a-switch__label">
            {{ state.label }}
        </div>
    </div>
</template>
